<template>
  <div class="wrapper">
    <section class="body_header" v-if="viewActive=='controlPoint'">
      <p class="header_title">Edificios</p>
    </section>
    <section class="body_edificios" v-if="edificiosComp.length > 0">
      <div class="body_edificios_list">
        <p
          class="header"
          :class="{'header--updateUser': styleUpdate}"
          v-if="viewActive=='updateUser'"
        >Edificios relacionados</p>
        <div class="body_edificios_item" v-for="(item, index) in edificiosComp" :key="index">
          <div class="item_checkbox">
            <b-checkbox
              type="is-info"
              size="is-large"
              v-model="aux[item.id]"
              :true-value="true"
              :false-value="false"
              @input="linkUnlink(item.id)"
              :disabled="!role"
            ></b-checkbox>
          </div>
          <div
            class="label-custom nombre_edificio"
            :class="{'nombre_edificio--updateUser': styleUpdate}"
          >{{item.slug}}</div>
          <input
            v-if="viewActive=='controlPoint' && download[item.id]"
            type="text"
            class="label-custom input-desc"
            placeholder="Descripcion"
            v-model.lazy="description[item.id]"
            @blur="actualizarLink(item.id)"
          >
          <div class="image-upload" v-if="viewActive=='controlPoint' && download[item.id]">
            <label class="image-box">
              <input
                class="file-input"
                type="file"
                name="image"
                :id="`imageUploader-${item.id}`"
                accept="image/*"
                @change="uploadImage(item.id)"
              >
              <span v-if="imageName[item.id]">{{imageName[item.id]}}</span>
              <span v-else>Agregar Foto (720 x 240)</span>
            </label>
          </div>
          <div class="option_select" v-show="viewActive=='controlPoint'">
            <a
              :href="qr[item.id]"
              class="button button-custom-actions ripple btn-space btn-struct-right"
              v-if="download[item.id]"
              :download="`${item.name} - ${currentCP.name}`"
            >
              <span style="margin-right: 5px;">Descargar QR</span>
              <i class="material-icons icon-download space-item">cloud_download</i>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { service } from "@/helper/Rest";
import { mapGetters } from "vuex";
export default {
  name: "edificios_cp",
  props: {
    viewActive: String,
    currentBuild: Array //edificos -FULLCONTENIDO- a los q pertenece el usuario
  },
  data() {
    return {
      changeBuild: [], //array de edificios linkeados suceptible al cambio del evento CHANGE
      aux: {},
      styleUpdate: false,
      qr: {},
      download: {},
      image: {},
      imageName: {},
      description: {},
      auxID: ""
    };
  },
  created() {
    this.styleUpdate = this.viewActive == "updateUser";
    this.$store.dispatch("GETBUILDINGS");
    if (this.$route.params.id) {
      if (this.currentlinkedbuildings) {
        for (var i of this.currentlinkedbuildings) {
          console.log({i});
          this.$set(this.aux, i._id, true);
          if (this.viewActive == "controlPoint") {
            this.qr[i._id] = i.QR;
            this.download[i._id] = true;
          }
          this.$set(this.description, i._id, i.description);
          if (i.image) {
            this.$set(this.imageName, i._id, i.image.originalname);
            this.$set(this.image, i._id, i.imagefull);
          }
        }
      }
      if (this.viewActive == "updateUser") {
        for (var i of this.currentBuild.filter(cb => Boolean(cb))) {
          this.$set(this.aux, i.id, true);
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "edificios",
      "cp_id",
      "currentCP",
      "role",
      "currentlinkedbuildings"
    ]),
    qrComp: function() {
      return this.qr;
    },
    downComp: function() {
      return this.download;
    },
    edificiosComp(){
      return this.edificios.filter(ed => Boolean(ed))
    }
  },
  methods: {
    check(n) {
      if (n) {
        for (var item of n) {
          if (item) {
            this.$set(this.aux, item.id, true);
            if (this.viewActive == "controlPoint") {
              this.qr[item.id] = item.QR;
              this.download[item.id] = true;
            }
          }
        }
      }
    },
    addBuildLocal: function(id) {
      this.linkBuildingList.push(id);
      this.$store.commit("addListBuild", this.linkBuildingList);
    },
    toastOpen(dato) {
      if (dato == "link") {
        this.$toast.open({
          message: "Se ha establecido la relación con el edificio",
          position: "is-bottom-right",
          type: "ffcolor-is-success"
        });
      }
      if (dato == "upodate") {
        this.$toast.open({
          message: "Se ha actualizado la relación con el edificio",
          position: "is-bottom-right",
          type: "ffcolor-is-success"
        });
      }
      if (dato == "unlink") {
        this.$toast.open({
          message: "Se ha eliminado la relación con el edificio",
          position: "is-bottom-right",
          type: "ffcolor-is-delete"
        });
      }
    },
    linkUnlink: function(id) {
      if (this.viewActive == "updateUser") {
        if (this.aux[id]) {
          service
            .putLinkBuild(
              this.$store.getters.company_id,
              this.$route.params.id,
              id
            )
            .then(response => {
              this.toastOpen("link");
            });
        } else {
          service
            .delUnlinkBuild(
              this.$store.getters.company_id,
              this.$route.params.id,
              id
            )
            .then(response => {
              this.toastOpen("unlink");
            });
        }
      } else if (this.viewActive == "controlPoint") {
        if (this.$route.params.id) {
          if (this.aux[id]) {
            this.$store
              .dispatch("POSTCPLINKBUILD", {
                id_checkpoint: this.$route.params.id,
                id_building: id
              })
              .then(response => {
                this.$set(this.download, id, true);
                this.$set(this.qr, id, response.QR);
                this.toastOpen("link");
              });
          } else {
            this.$store
              .dispatch("DELCPUNLINKBUILD", {
                id_checkpoint: this.$route.params.id,
                id_building: id
              })
              .then(response => {
                this.$set(this.download, id, false);
                this.toastOpen("unlink");
              });
          }
        } else {
          if (this.aux[id]) {
            this.$store
              .dispatch("POSTCPLINKBUILD", {
                id_checkpoint: this.cp_id,
                id_building: id
              })
              .then(response => {
                this.$set(this.download, id, true);
                this.$set(this.qr, id, response.QR);
                this.toastOpen("link");
              });
          } else {
            this.$store
              .dispatch("DELCPUNLINKBUILD", {
                id_checkpoint: this.cp_id,
                id_building: id
              })
              .then(response => {
                this.$set(this.download, id, false);
                this.toastOpen("unlink");
              });
          }
        }
      }
    },
    uploadImage(id) {
      this.auxID = id;
      var oFReader = new FileReader();
      // console.log(oFReader);

      oFReader.readAsDataURL(
        document.getElementById(`imageUploader-${id}`).files[0]
      );
      oFReader.onload = oReader => {
        this.$set(
          this.image,
          id,
          document.getElementById(`imageUploader-${id}`).files[0]
        );
        this.$set(
          this.imageName,
          id,
          document.getElementById(`imageUploader-${id}`).files[0].name
        );
        this.actualizarLink(id);
      };
      oFReader.onerror = oFReader => {
        // console.log(oFReader);
      };
    },
    actualizarLink(id) {
      var obj = {};
      if (this.description[id]) {
        this.$set(obj, "description", this.description[id]);
      }
      if (this.image) {
        this.$set(obj, "image", this.image[id]);
      }
      // console.log(obj);

      if (this.viewActive == "controlPoint") {
        if (this.$route.params.id) {
          if (this.aux[this.auxID]) {
            this.$store
              .dispatch("PUTCPLINKBUILD", {
                id_checkpoint: this.$route.params.id,
                id_building: this.auxID,
                payload: obj
              })
              .then(response => {
                this.toastOpen("update");
              });
          }
        } else {
          if (this.aux[this.auxID]) {
            this.$store
              .dispatch("PUTCPLINKBUILD", {
                id_checkpoint: this.cp_id,
                id_building: this.auxID,
                payload: obj
              })
              .then(response => {
                this.toastOpen("update");
              });
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/2.tools/mixins/_mediaquerys";
.b-checkbox.checkbox input[type="checkbox"]:checked + .check {
  background-color: #2ecc71 !important;
  box-shadow: none !important;
  border-color: #2ecc71 !important;
}
.body_edificios {
  width: fit-content;
}
.body_edificios_list {
  border: 1px solid #e0e0e0;
  padding: 15px;
  // box-shadow: 0px 0px 0.5px 0px rgba(0, 0, 0, 0.75);
  // margin: 25px;
  // width: 675px;
}
.body_edificios_item {
  display: flex;
  // justify-content: space-around;
  padding: 10px 10px;
  flex-flow: row wrap;
  .item_checkbox {
    .check {
      border: 2px solid #e6e4e6 !important;
    }
  }
  .option_select {
    margin-left: 43px;
    margin-top: 10px;
    // min-width: 40%;
    @include media-md() {
      margin-left: 5px;
    }
  }
  .image-upload {
    height: 40px;
    width: 250px;
    margin: 10px 0px 0 43px;
    // @include navegators(0px 3px 3px 0px #6b6b6b);
    // @include navegators(0px 3px 2px -3px rgba(0, 0, 0, 0.75));
    // box-shadow: 0px 3px 2px -3px rgba(0, 0, 0, 1);
    // box-shadow: 0px 3px 1px -3px rgba(0, 0, 0, 0.75);
    border: thin solid #e6e4e6;
    display: flex;
    justify-content: space-around;
    align-items: center;
    cursor: pointer;
    color: #5e5e5e;
    // padding: 25px 20px;
    padding-top: 25px;
    padding-bottom: 25px;
    .image-box {
      cursor: pointer;
      color: #5e5e5e;
      font-size: 15px;
      .file-input {
        height: 0.01em;
        left: 0;
        outline: none;
        position: absolute;
        top: -30px;
        width: 0.01em;
      }
    }
  }
  @include media-lg() {
    flex-flow: row nowrap;
    .option_select {
      margin: 0;
    }
    .image-upload {
      margin: 0 10px;
      width: 200px;
    }
  }
}
.nombre_edificio {
  color: #5e5e5e;
  // width: 400px;
  margin: 0 !important;
  min-width: 200px !important;
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  // height: fit-content;
  &--updateUser {
    min-width: 200px !important;
  }
}
.item_checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
}
.space-item {
  max-width: 25px;
  margin-left: 5px;
}
.btn-space {
  padding-left: 20px;
  padding-right: 20px;
  // margin-left: 20px;
}
.header {
  font-size: 25px;
  font-weight: bold;
  text-align: start;
  padding: 10px 0;
  margin: 25px;
  &--updateUser {
    margin: 0;
  }
}
.body_header {
  width: 100%;
}
.header_title {
  font-size: 25px;
  font-weight: bold;
  text-align: start;
  margin: 0;
  padding-left: 0;
  padding-top: 10px;
  padding-bottom: 10px;
}
.wrapper {
  padding-left: 30px;
  padding-right: 30px;
  // max-width: 700px;
  @include media-xl() {
    padding: 0 200px 0 30px;
  }
}
.check-struct-left {
  margin-right: 10px;
}
.input-desc {
  height: 50px;
  border: thin solid #e6e4e6;
  padding: 10px 20px;
  border-radius: 2px;
  min-width: 200px !important;
  width: 250px !important;
  margin: 10px 0px 0 43px;
  font-size: 1rem;
  @include media-md() {
    margin: 0 5px;
  }
  @include media-lg() {
    margin: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/PuntoControlEdificio.vue